import { gql } from 'graphql-tag'

export const ASK_AI_SUBSCRIPTION = gql`
  subscription Ask($q: String!) {
    ask(question: $q)
  }
`
export const ASK_AI_ACCESS_FLAG_KEY = 'askAiAccess'
